module.exports = __webpack_public_path__ + "img/bg-dashboard-blue.26b23576.png";